import React from 'react'
import {useSelector} from 'react-redux'
import { Fragment} from 'react'
import _ from 'lodash'

let Sidebar = function(props){

  let sidebar_code = useSelector(state => state.sidebar_code).trim()
  const sidebar_width = useSelector(state => state.sidebar_width) ? useSelector(state => state.sidebar_width) : "3"

  return (
    <Fragment>
      {sidebar_code && sidebar_code != "" && (
        <div className={"r-inner-container-sidebar" + " col-md-" + sidebar_width} dangerouslySetInnerHTML={{ __html: sidebar_code}}>
        </div>)
      }
    </Fragment>
  )
}
export default Sidebar;